import { render, staticRenderFns } from "./TestuserBuilder.vue?vue&type=template&id=52b1ff54&scoped=true&"
import script from "./TestuserBuilder.vue?vue&type=script&lang=js&"
export * from "./TestuserBuilder.vue?vue&type=script&lang=js&"
import style0 from "./TestuserBuilder.vue?vue&type=style&index=0&id=52b1ff54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b1ff54",
  null
  
)

export default component.exports